import HeaderAppBar from "@/Layouts/views/Header/components/HeaderAppBar";
import ContentTop, { IContentTopProps } from "./ContentTop";

export interface HeaderContainerProps extends IContentTopProps {
	onLogoutAction?: () => void;
}

export default function HeaderContainer(props: Readonly<HeaderContainerProps>) {
	return (
		<>
			<HeaderAppBar onLogoutAction={props.onLogoutAction} />
			<ContentTop {...props} />
		</>
	);
}
